import type { FaireProductEntity } from "../../entity_types/product";

export const p_2bjx9im5: FaireProductEntity = {
  token: "p_2bjx9im5",
  type: "product",
  name: "Retirement Saturdays Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a8d8d8e27750147408855ca166a7e367880a1879ca9fbbbf7e32684105e94b82.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2eae9f14ac4a4bd7bcb010c45d6ad96054a76d0c33317001830b763bcfd2107b/1528389078.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:07.234Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
